import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuInfo, LuTag} from 'react-icons/lu'

export function PrescribedNameDrawerTabsList() {
  const {t} = useTranslate('common')

  return (
    <Tabs.List>
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>

      <Tabs.Trigger value="trade-names" data-e2e="trade-names-trigger">
        <LuTag />
        {t('trade_names')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
